import React from 'react';

function Hospitality({ size, strokeWidth, stroke, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path
        d="M21.375 23.7937C23.4075 22.4425 24.8541 20.373 25.425 18C27.1125 18 27.5063 14.4563 27.5063 13.8938C27.5063 13.3313 27.5625 12.4312 25.875 12.375V10.6875"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M14.5688 23.7937C12.5364 22.4425 11.0897 20.373 10.5188 18C8.83135 18 8.4376 14.4563 8.4376 13.8938C8.4376 13.3313 8.38135 12.4312 10.0688 12.375V10.6875"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M13.5 22.9502V24.7502C13.5 25.8752 14.0625 27.5627 7.875 28.6877C1.6875 29.8127 1.125 34.8752 1.125 34.8752H34.875C34.875 34.8752 34.875 29.9814 28.125 28.6877C21.375 27.3939 22.5 25.8752 22.5 24.7502V22.9502"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M10.125 7.0875C13.5 6.69375 22.5 6.58125 25.875 7.0875M10.125 10.6312C13.5 9.95625 22.5 10.0125 25.875 10.6312V4.5C25.875 2.25 23.625 1.125 18 1.125C12.375 1.125 10.125 2.25 10.125 4.5V10.6312Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M18 26.1V34.875M13.5 24.75C14.8734 25.5466 16.4149 26.009 18 26.1C19.5844 26.0049 21.1249 25.5428 22.5 24.75H13.5ZM11.25 27.8438C11.9991 28.9501 13.0036 29.86 14.1784 30.4963C15.3533 31.1327 16.6641 31.477 18 31.5C19.3359 31.477 20.6467 31.1327 21.8216 30.4963C22.9964 29.86 24.0009 28.9501 24.75 27.8438H11.25Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
}

export default Hospitality;
